import { render, staticRenderFns } from "./GridWithChoice.vue?vue&type=template&id=fe9b407e&scoped=true"
import script from "./GridWithChoice.vue?vue&type=script&lang=js"
export * from "./GridWithChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9b407e",
  null
  
)

export default component.exports